// Copyright (c) 2019 Deere & Company

// import alertsReducer from './reducers/alerts';
import alertsReducer from '../../shared/reducer/alerts';
import busyCounter from '../../shared/reducer/busy-counter';
import { combineReducers } from 'redux';
import factoriesReducer from './reducers/factories';


export const getApplicationReducers = () => combineReducers( {
    // alerts: alertsReducer,
    busyCounter,
    alerts: alertsReducer,
    factories: factoriesReducer,
} );
